import React, { useEffect } from "react";
// Layout
import { Tab, Tabs } from "react-bootstrap";
import NavigationBar from "../navigation/NavigationBar";
import SidebarPatient from "../sidebars/SidebarPatient";
import Footer from "../Footer";
import InfoTabPatient from "../sharedInfoPageTabs/InfoTabPatient";
// icons & pngs
import PatientLogo from "../../img/user/patient.png";

interface InformationPagePatientProps {
  title: string;
}

const InformationPagePatient = ({ title }: InformationPagePatientProps) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return (
    <div id="body">
      {/* navigation bar (bar on the top) */}
      <NavigationBar />
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar (bar on the side) */}
          <SidebarPatient />
          {/* Content */}
          <div className="col container p-3" id="main-content">
            <h3>Informationen zu SysDok</h3>
            <Tabs defaultActiveKey="patient" className="mb-3">
              {/* for patients/ Für Patient*innen */}
              <Tab
                eventKey="patient"
                title={
                  <div>
                    <i className="mdi">
                      <img
                        className="rounded-circle "
                        src={PatientLogo}
                        width="25px"
                        alt="Patient"
                      />
                    </i>
                    <span> Für Patient*innen</span>
                  </div>
                }
              >
                <div className="m-3">
                  <InfoTabPatient />
                </div>
              </Tab>
            </Tabs>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};
export default InformationPagePatient;
